module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-50-13-081.15b5a9b8.mp4";